import { client } from './client';

export const crossReferralApi = {
  getSettings: () => client.get('get_cross_referral_settings'),
  saveSettings: (data) => client.post('save_cross_referral_settings', data),
};
